module.exports = __webpack_public_path__ + "static/media/ufo.cec15d2e.svg";